import { PrismicRichText } from "@prismicio/react";
import React from "react";
import * as s from "./index.module.scss";
import TitleSection from "../titleSection";

const HowItWorksSection = ({ data }) => {
  return (
    <div className="section_wrapper section section_color-off">
      <TitleSection
        title={data.how_it_works_title}
        description={data.how_it_works_description}
        maxWidth={522}
      />
      <div className={`mx-auto w-100  ${s.faq_wrapper}`}>
        {data.steps.map((item, idx) => {
          const isLast = idx === data.steps.length - 1;
          return (
            <div key={idx} className={isLast ? "" : "mb-4"}>
              <div className={`d-flex mx-auto w-100 ${s.step_wrapper}`}>
                <div className={s.number_circle}>{`0${idx + 1}`}</div>
                <div className={s.text_title}>
                  <PrismicRichText field={item.step_title} />
                </div>
              </div>
              <PrismicRichText field={item.step_description} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HowItWorksSection;
